/*
 * Plugin-config.ts
 * Description: Includes the declaration Vue plugins
 */

// ================= Importing Vue =================

import Vue from 'vue';

// ================= Importing plugins =================

// Importing Axios (used for HTTP requests)
import Axios from 'axios';
// Importing refresh token function
import {refreshToken} from '@/ts/helpers';

// Importing Bootstrap for Vue
import BootstrapVue from 'bootstrap-vue';
// Importing bootstrap related css and javascript
// import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// import $ from 'jquery';
import 'popper.js';

// Importing Vue Router
import VueRouter from 'vue-router';
// Importing routes
import routes from '@/config/routes';
// Importing route guard function
import {routeGuard} from '@/config/routes-guard';

// Importing SweetAlert2
import Swal from 'sweetalert2';

// Importing Vuex Store
import Vuex from 'vuex';
import {data} from '@/ts/vuex/vuex-store';

// Importing Vue Google Maps
import * as VueGoogleMaps from 'vue2-google-maps';
import {GMJSAK} from '@/ts/variables';

// Importing Vue Modal
import vmodal from 'vue-js-modal';

// Importing Vue Datetime
import Datetime from 'vue-datetime';

// ================= Initializing plugins =================

/**
 * We'll load Vur Router and create a new router instance. The router variable
 * is importable because of the main.ts file.
 */

export const router = new VueRouter ({
    routes,
    mode: 'history',
    // scrollBehavior(to, from, savedPosition) {
    //     return { x: 0, y: 0 };
    // },
});
router.beforeEach(routeGuard);
Vue.use(VueRouter);

/**
 * Next, we'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs.
 */

// Vue.prototype.$ = $;
Vue.use(BootstrapVue);

/**
 * Next, we'll load SweetAlert2. This plugin is used for showing dynamic
 * alerts to the user.
 */

Vue.prototype.$swal = Swal;

/**
 * Next, we'll load Vue Modal. This plugin is used for showing dynamic
 * modals to the user.
 */

Vue.use(vmodal);

/**
 * Next, we'll load Vue Date time picker. This plugin is used for picking
 * date and time.
 */

Vue.use(Datetime);

/**
 * Next, we'll load VueGoogleMaps. This plugin is used for
 * google maps to the user
 */

Vue.use(VueGoogleMaps, {
    load: {
        key: GMJSAK,
        libraries: 'places, directions',
    },
});

/**
 * Then, we'll load Vuex. This plugin is used for state management
 * from different files.
 */

Vue.use(Vuex);
export const store = new Vuex.Store(data);

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

Vue.prototype.Axios = Axios;
// Setting up common headers
Vue.prototype.Axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
Vue.prototype.Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Setting up an JWT auto-refresh
Axios.interceptors.response.use(undefined, (error) => {
    if (error.hasOwnProperty('response') && error.response !== undefined) {
        const err = error.response.data;
        if (err.hasOwnProperty('errors') && err.errors.hasOwnProperty('token') &&
            err.errors.token === 'Authorization token expired.') {
            refreshToken().then(() => {
                error.config.headers.Authorization = 'Bearer ' + localStorage.getItem('jwt');
                // error.config.baseURL = undefined;
                return Axios.request(error.config);
            });
        }
    }
    return Promise.reject(error);
});

